<!-- this feature will be added later -->

<template>
  <div>
    <!-- <div class="notification">
      <span class="badge">18</span>
      <img src="@/assets/images/units_to_aprove_icon.svg" alt="icon">
    </div> -->
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
